module.exports = __webpack_public_path__ + "img/upload-button.ce830726.svg";